export default __webpack_public_path__ + "static/media/UI_ButtonCommentSendDisabled.7902a629.png";